import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import { pickContextTypes } from '../../context-types';

import Icon from 'widget/player-widget/components/icon/icon';
import ProgressBar from 'widget/player-widget/components/progress-bar/progress-bar';
import ControlButton from '../../control-button/control-button';

import styles from './volume.styl';


@WixConnect(styles)
class Tooltip extends React.Component {

  static contextTypes = pickContextTypes('toggleMute', 'setVolume', 'volume', 'muted');

  @autobind
  changeVolume(e) {
    const { toggleMute, setVolume } = this.context;

    setVolume(e.target.value / 100);
    toggleMute(false);
  }

  stopEventPropagation(event) {
    event.stopPropagation();
  }

  render() {
    const { volume, muted } = this.context;

    return (
      <div styleName="mute__track"
           onClick={this.stopEventPropagation}>
        <ProgressBar orientation="vertical"
                     styleName="level"
                     fillClassName={styles['level-fill']}
                     inputClassName={styles['level-input']}
                     onChange={this.changeVolume}
                     progress={muted ? 0 : volume * 100} />
      </div>
    );
  }
}

@WixConnect(styles)
export default class Volume extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
  };

  static contextTypes = pickContextTypes('toggleMute', 'volume', 'muted', 'fullScreen');

  get volumeIconName() {
    const { muted, volume } = this.context;
    if (muted || (volume <= 0)) {
      return 'volume-mute';
    }
    if (volume > 0 && volume <= 0.5) {
      return 'volume-50';
    }

    return 'volume-100';
  }

  render() {
    const { className } = this.props;
    const { toggleMute, fullScreen } = this.context;
    const styleNames = classnames('mute', {
      'at-full-screen': fullScreen,
    });

    return (
      <ControlButton styleName={styleNames}
                     className={className}
                     onClick={toggleMute}
                     tooltip={{ content: <Tooltip />, position: 'center' }}>
        <Icon styleName="icon"
              name={this.volumeIconName} />
      </ControlButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/controls/volume/volume.js